module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/expendientes/expendientes.component.css
// module id = ./src/app/components/expendientes/expendientes.component.css
// module chunks = main